import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const FAQS = [
  { q: 'Não entendo nada de marketing. Vocês me ajudam?', a: 'Sim, é para isso que a gente existe. Você conta o que precisa e a gente cuida de tudo, do começo ao fim, explicando cada passo de forma simples.' },
  { q: 'Vocês vão até a minha empresa?', a: 'Vamos. Levamos câmeras, luz, áudio e drone até você em Foz do Iguaçu e região. Você não precisa ter nada.' },
  { q: 'Em quanto tempo fica pronto?', a: 'Depende do serviço. Vídeos costumam sair em poucos dias, sites e landing pages em algumas semanas. Combinamos o prazo antes de começar.' },
  { q: 'Quanto custa?', a: 'Depende do que sua empresa precisa. Chama no WhatsApp, entendemos seu caso e mandamos um orçamento sem compromisso.' },
];

export const ShortFAQ = () => (
  <section className="px-6 sm:px-10 lg:px-16 py-24 grid lg:grid-cols-[1fr_1.4fr] gap-12" data-testid="short-faq">
    <div>
      <p className="sh-mono text-xs sm:text-sm text-[var(--sh-teal)] mb-4">// Dúvidas</p>
      <h2 className="sh-display text-6xl sm:text-7xl">Perguntas <br />rápidas</h2>
    </div>
    <Accordion type="single" collapsible className="border-t border-white/10">
      {FAQS.map((f, i) => (
        <AccordionItem key={f.q} value={`faq-${i}`} className="border-white/10">
          <AccordionTrigger className="py-6 text-lg sm:text-xl font-semibold hover:no-underline hover:text-[var(--sh-teal)] transition-colors" data-testid={`faq-trigger-${i}`}>
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-base text-[#F2F2EE]/75 leading-relaxed pr-6" data-testid={`faq-answer-${i}`}>
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
